'use client';
import PrivacyContent from '@/components/common/privacy-content';
import PrivacyHero from '@/components/privacy-hero';
import dynamic from 'next/dynamic';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import BorderEdge from '@/components/common/border-edge';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <PrivacyHero className="policy-height" pageTitle="Privacy Policy" />
            <DefaultBreadcrumb parentPage="Technologies" currentPage="Privacy Policy" />
            <PrivacyContent />
            <BorderEdge color="text-white" bg="bg-blue" />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
